"use strict";
/*
 * Created on 09 01 2020
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var CodebookLookupSequence_1 = require("../../core/model/codebook/CodebookLookupSequence");

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var ValidationResult_1 = require("../../core/model/errors/ValidationResult");

var ReleaseState_1 = require("../../release/model/ReleaseState");

var ReleaseType_1 = require("../../release/model/ReleaseType");

var ReleaseWorkflowType_1 = require("../../release/model/ReleaseWorkflowType");

var UserInfo_1 = require("../../user/model/UserInfo");
/**
 * <p>Simple release with just the most basic meta data. It represents a release of regular prices on specific sites.
 * Individual prices are represented by {@link SiteReleaseItem}.</p>
 *
 * @author Jaroslav Sevcik
 * @author JMe
 */


var SiteRelease =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SiteRelease, _DomainObject_1$Domai);

  /**
   * Ctor.
   *
   * @param id Corresponds to {@link IPriceRelease.id}.
   * @param name Corresponds to {@link IPriceRelease.name}.
   * @param created Corresponds to {@link IPriceRelease.created}.
   * @param createdBy Corresponds to {@link IPriceRelease.createdBy}.
   * @param lastModified Corresponds to {@link IPriceRelease.lastModified}.
   * @param lastModifiedBy Corresponds to {@link IPriceRelease.lastModifiedBy}.
   * @param priceListTypeId Corresponds to {@link IPriceRelease.priceListTypeId}.
   * @param releaseType The type of release. RECONSIDER ADDITION TO THE ABSTRACT (IPriceRelease).
   * @param workflowType Corresponds to {@link IPriceRelease.id}. RECONSIDER ADDITION TO THE ABSTRACT (IPriceRelease).
   * @param state Corresponds to {@link IPriceRelease.state}.
   * @param description Corresponds to {@link IPriceRelease.description}.
   * @param exportProgressMonitorId Identification of progress related to export of this release process. If there is no export
   *        process in run, there will be no reference.
   * @param exported date and time of last prices export; null if not exported (yet)
   * @param validation Validation result aggregated to entire process.
   *        May aggregate summary info in case of errors within some {@link SelloutTerminationItem items}.
   */
  function SiteRelease(id, name, created, createdBy, lastModified, lastModifiedBy, priceListTypeId, releaseType, workflowType, state, description, exportProgressMonitorId, exported, validation) {
    var _this;

    _classCallCheck(this, SiteRelease);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SiteRelease).call(this));
    _this.id = id;
    _this.name = name;
    _this.created = created;
    _this.createdBy = createdBy;
    _this.lastModified = lastModified;
    _this.lastModifiedBy = lastModifiedBy;
    _this.priceListTypeId = priceListTypeId;
    _this.releaseType = releaseType;
    _this.workflowType = workflowType;
    _this.state = state;
    _this.description = description;
    _this.exportProgressMonitorId = exportProgressMonitorId;
    _this.exported = exported;
    _this.validation = validation;
    return _this;
  }

  return SiteRelease;
}(DomainObject_1.DomainObject);

exports.SiteRelease = SiteRelease;
/**
 * Hard coded value of priority of price list related to this type of release.
 * <br/>
 * Move this to configuration to remove client dependency.
 */

SiteRelease.PRICE_LIST_PRIORITY = 153;

SiteRelease.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SiteRelease.name);
  return {
    id: builder.id('id'),
    name: builder.str('name'),
    created: builder.date('created', DateParser_1.DateParser.ISO_PATTERN),
    createdBy: builder.obj('createdBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    lastModified: builder.date('lastModified', DateParser_1.DateParser.ISO_PATTERN),
    lastModifiedBy: builder.obj('lastModifiedBy', UserInfo_1.UserInfo.schema, function (mat) {
      return new UserInfo_1.UserInfo(mat.id, mat.name);
    }),
    priceListTypeId: builder.lookup('priceListTypeId', CodebookLookupSequence_1.CodebookLookupSequence.PriceListType),
    releaseType: builder.senum('releaseType', ReleaseType_1.ReleaseType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseType),
    workflowType: builder.senum('workflowType', ReleaseWorkflowType_1.ReleaseWorkflowType, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseWorkflowType),
    state: builder.senum('state', ReleaseState_1.ReleaseState, CodebookLookupSequence_1.CodebookLookupSequence.ReleaseState),
    description: builder.opt(builder.str('description').withDescription({
      multiline: true
    })),
    exportProgressMonitorId: builder.opt(builder.str('exportProgressMonitorId')),
    exported: builder.opt(builder.date('exported', DateParser_1.DateParser.ISO_PATTERN)),
    validation: builder.obj('validation', ValidationResult_1.ValidationResult.schema, function (mat) {
      return new ValidationResult_1.ValidationResult(mat.resultObjects);
    })
  };
}();